import { Link } from 'react-router-dom';
import type { Comic } from '@/types/comic';
import { categoryName, formatCount } from '@/utils/comic';

const rankColors = [
  'bg-accent-500 text-foreground-950',
  'bg-accent-300 text-foreground-950',
  'bg-accent-200 text-foreground-900',
];

export default function PopularList({ comics }: { comics: Comic[] }) {
  return (
    <section className="bg-background-100 py-10 md:py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-6 flex items-end justify-between gap-4">
          <div>
            <h2 className="flex items-center gap-2 text-xl font-bold text-foreground-950 md:text-2xl">
              <span className="h-5 w-1 rounded-full bg-primary-500" />
              热门漫画推荐
            </h2>
            <p className="mt-1 text-sm text-foreground-500">根据全站人气实时排序，大家都在追</p>
          </div>
          <Link
            to="/category/all?sort=hot"
            className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm text-primary-600 transition-colors hover:text-primary-700"
          >
            人气榜单
            <i className="ri-arrow-right-s-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:gap-4 lg:grid-cols-2">
          {comics.map((c, i) => (
            <Link
              key={c.id}
              to={`/detail/${c.id}`}
              className="group flex items-center gap-4 rounded-lg border border-background-200/80 bg-background-50 p-3 transition-colors duration-300 hover:border-primary-300 cursor-pointer"
            >
              <span
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-sm font-bold ${
                  rankColors[i] || 'bg-background-200 text-foreground-600'
                }`}
              >
                {i + 1}
              </span>
              <div className="h-20 w-14 shrink-0 overflow-hidden rounded-md bg-background-100">
                <img
                  src={c.cover}
                  alt={`${c.title} 漫画封面`}
                  title={`${c.title} 热门韩漫`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {c.title}
                </h3>
                <p className="mt-1 truncate text-xs text-foreground-500">
                  {c.author} · {c.categories.map(categoryName).join(' / ')}
                </p>
                <p className="mt-1.5 line-clamp-1 text-xs text-foreground-600">{c.description}</p>
              </div>
              <div className="hidden shrink-0 flex-col items-end gap-1 sm:flex">
                <span className="flex items-center gap-1 text-xs text-accent-700">
                  <i className="ri-fire-line" />
                  {formatCount(c.views)}
                </span>
                <span className="text-[11px] text-foreground-400">第{c.chapterCount}话</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}